export default __webpack_public_path__ + "static/media/userInActive.f2906a1d.svg";